import { Component, EventEmitter, Input, OnInit, Output, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { ColumnModel } from '../../../../models/dx-data-table.model';
import { Observable } from 'rxjs';
import { CtlGasBirimDosyaBelgeAramaService } from './ctl-gas-birim-dosya-belge-arama.service';
import { CtlGasBirimDosyaBelgeService } from '../ctl-gas-birim-dosya-belge.service';
import { OrtakService } from '../../../../services/ortak.service';
import { DxButtonModule } from 'devextreme-angular';
import { DkDxDataCtlTableComponent } from '../../../components';
import {DlistDto} from "@dabnet-kamu/libs/ui";

@Component({
  selector: 'dk-ctl-gas-birim-dosya-belge-arama',
  standalone: true,
  imports: [CommonModule,DkDxDataCtlTableComponent, DxButtonModule],
  templateUrl: './ctl-gas-birim-dosya-belge-arama.component.html',
  styleUrls: ['./ctl-gas-birim-dosya-belge-arama.component.scss'],
})
export class CtlGasBirimDosyaBelgeAramaComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  public data: any;
  public columns: ColumnModel[];
  public selectedData: any = null;
  gridControlsList$: Observable<DlistDto>;
  @Input() control: any;
  @Output() private closePopup = new EventEmitter<string>();

  constructor(
    private service: CtlGasBirimDosyaBelgeAramaService,
    private gasBirimDosyaPlanService:CtlGasBirimDosyaBelgeService,
    public ortakService:OrtakService
  ) {

  }

  ngOnInit(): void {
    this.data = this.service.getData(this.control);
    this.gridControlsList$ = this.gasBirimDosyaPlanService.gridControlsList$;
    this.gasBirimDosyaPlanService.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x=>{
      this.columns = this.ortakService.setRecursiveFieldData([x],false);
      })

  }

  focusChanged(e: any) {
    this.selectedData = e.row;
  }

  
  onKeyDown(e: any) {
  if (e.event?.key === 'Enter') {
      this.closePopup.emit(this.selectedData);
    }
  }
  
  dblClickRow(e:any){
    this.closePopup.emit(e);
  }

  chooseBtnClick() {
    this.closePopup.emit(this.selectedData);
  }

  cancelBtnClick() {
    this.closePopup.emit(null);
  }
}
